export const TASK_CREATED = "TASK_CREATED";
export const TASK_CONNECTED_TO_CONSUMER = "TASK_CONNECTED_TO_CONSUMER";
export const TASK_CONNECTED_TO_OFFICE = "TASK_CONNECTED_TO_OFFICE";
export const TASK_DISCONNECTED_FROM_OFFICE = "TASK_DISCONNECTED_FROM_OFFICE";
export const TASK_CONNECTED_TO_EMPLOYEE = "TASK_CONNECTED_TO_EMPLOYEE";
export const TASK_ASSIGNED_TO_MANAGERS = "TASK_ASSIGNED_TO_MANAGERS";
export const TASK_STORED_ATTEMPT = "TASK_STORED_ATTEMPT";
export const TASK_NOT_RESOLVED = "TASK_NOT_RESOLVED";
export const TASK_TRANSFERRED_TO_EMPLOYEE = "TASK_TRANSFERRED_TO_EMPLOYEE";
